// extracted by mini-css-extract-plugin
var _1 = "SearchInput-module__animatedBackground--pIml5";
var _2 = "SearchInput-module__searchInput--k3Ity";
export { _1 as "animatedBackground", _2 as "searchInput" }
